import React, { Component } from "reactn";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button/Button";

import { ScaryButton } from "js/react/components/UiComponents";
import DialogContent from "./DialogContent";
import BeautifulDialog from "./BeautifulDialog";

export default class ConfirmationScaryDialog extends Component {
    render() {
        const {
            title,
            message,
            warning,
            cancelCallback,
            cancelButtonLabel,
            acceptCallback,
            okButtonLabel,
            closeDialog,
            buttonOptions = {},
        } = this.props;

        let classes = null;
        if (warning) {
            classes = { paper: "error-dialog" };
        }

        return (
            <BeautifulDialog
                classes={classes}
                closeDialog={() => closeDialog(false)}
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>{message}</DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            cancelCallback && cancelCallback();
                            closeDialog(false);
                        }}
                    >
                        {cancelButtonLabel || "Cancel"}
                    </Button>
                    {
                        buttonOptions.acceptButtonColor === "red" ? (
                            <ScaryButton
                                onClick={() => {
                                    acceptCallback && acceptCallback();
                                    closeDialog(true);
                                }}
                            >
                                {okButtonLabel || "Ok"}
                            </ScaryButton>
                        ) : (
                            <Button
                                color="primary"
                                onClick={() => {
                                    acceptCallback && acceptCallback();
                                    closeDialog(true);
                                }}
                            >
                                {okButtonLabel || "Ok"}
                            </Button>
                        )
                    }
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
